import uniqBy from "lodash/uniqBy";

import {IntermediatePart} from "../intermediatePart";
import store from "../../../../store";

export default class CountertopCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  fixEdgeMeta(dbFeature) {
    if (dbFeature.metaData["Edge"]) {
      const metaValue = Array.isArray(dbFeature.metaData["Edge"]) ? dbFeature.metaData["Edge"][0] : dbFeature.metaData["Edge"];
      switch (metaValue) {
        case "European Edge":
          dbFeature.metaData["Edge"] = "Eased";
          break;
        case "Polished":
        case "Polished Edge":
        case "Top and bottom round":
        case "Top and Bottom Round":
          dbFeature.metaData["Edge"] = "Pencil";
          break;
        case "Waterfall Edge":
          dbFeature.metaData["Edge"] = "Waterfall";
          break;
        default:
          dbFeature.metaData["Edge"] = metaValue.split(" Edge")[0];
          break;
      }
    } else {
      // console.log("No Edge Metadata", dbFeature);
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);

    let newFeatures = uniqBy(this.getSameEdgesFeatures(featuresToDisplay), (feature) => {
      return feature.dbFeature.id && feature.getSplittedFeatureName()
    });

    for (let i = 0; i < featuresToDisplay.length; i++) {
      const currentFeature = featuresToDisplay[i];
      const currentFeatureName = currentFeature.getSplittedFeatureName();
      if (!newFeatures.some(addedFeature => {
        return addedFeature.dbFeature.id === currentFeature.dbFeature.id
          || addedFeature.getSplittedFeatureName() === currentFeatureName
      })) {
        newFeatures.push(currentFeature)
      }
    }

    return this.returnNavItemsFromFeatures(newFeatures)
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    if (!this.hasAdditionalParts) {
      return []
    }
    let activeFeatureParts = this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
    return activeFeatureParts
  }

  getActiveFeatureConditions() {
    if (this.activeFeature) {
      return [...this.getArrayOfConditions(), {
        propName: "Edge",
        propValue: this.activeFeature.metaData["Edge"]
      }]
    }
    return this.getArrayOfConditions()
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getSameEdgesFeatures(featuresToDisplay) {
    let currentEdgeMetaData = "";
    if (this.activeFeature && this.activeFeature.metaData["Edge"]) {
      currentEdgeMetaData = Array.isArray(this.activeFeature.metaData["Edge"]) ? this.activeFeature.metaData["Edge"][0] : this.activeFeature.metaData["Edge"];
    }
    if (!currentEdgeMetaData) {
      const edgeFeatureGroup = this.getParent().edge;
      if (edgeFeatureGroup && edgeFeatureGroup.activeFeature) {
        currentEdgeMetaData = edgeFeatureGroup.activeFeature.dbFeature.sharedFeatureName;
      }
    }
    if (currentEdgeMetaData) {
      featuresToDisplay = featuresToDisplay.filter((feature) => {
        return !feature.notAvailableInVisualizer && feature.metaData["Edge"] && (
          Array.isArray(feature.metaData["Edge"])
            ? feature.metaData["Edge"].includes(currentEdgeMetaData)
            : feature.metaData["Edge"] === currentEdgeMetaData
        )
      });
    }
    return featuresToDisplay
  }

  getFeatureEdgeFilter = (feature, edgeFilterGroup) => {
    if (!feature) {
      return null
    }
    if (!edgeFilterGroup) {
      const filterGroups = store.getState().filterState.filterGroups;
      edgeFilterGroup = filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
    }
    return feature.dbFeature.fabFilterValueIDs[edgeFilterGroup.id] || feature.dbFeature.filterValueIDs[edgeFilterGroup.id]
  };

  tryToSetTheSameFeature(filteredFeatures = [], partName = "") {
    if (this.activeFeature && this.activeFeature.partName) {
      let splittedFromTheLayoutName = partName
        ? this.removeLayoutFromPartName(partName)
        : this.activeFeature.getMatchingFeatureName();
      const allEdgesCountertops = filteredFeatures.filter(feature => {
        return feature.getMatchingFeatureName() === splittedFromTheLayoutName
      });
      const sameEdgeCountertops = this.getSameEdgesFeatures(allEdgesCountertops);
      this.activeFeature = sameEdgeCountertops[0] || allEdgesCountertops[0] || null
      if (this.activeFeature) {
        return true
      }
    }
    return false
  }

}
